import { Card, CardContent, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type SectionCardProps = {
  title: string;
  description?: string;
  children: ReactNode;
};

export function SectionCard({ title, description, children }: SectionCardProps) {
  return (
    <Card
      sx={{
        height: '100%',
        transition: 'box-shadow 200ms ease-out',
        '&:hover': { boxShadow: '0 4px 12px rgba(11,13,16,.06)' },
      }}
    >
      <CardContent>
        <Stack spacing={2.5}>
          <Stack spacing={0.75}>
            <Typography variant="h5">{title}</Typography>
            {description ? (
              <Typography variant="body2" color="text.secondary">
                {description}
              </Typography>
            ) : null}
          </Stack>
          {children}
        </Stack>
      </CardContent>
    </Card>
  );
}
